function getUrlParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function eventContentEllipsis() {
    $('.event-list-metacontent p').ellipsis({
        lines: 2,             // force ellipsis after a certain number of lines. Default is 'auto'
        ellipClass: 'ellip',  // class used for ellipsis wrapper and to namespace ellip line
        responsive: true      // set to true if you want ellipsis to update on window resize. Default is false
    });
}

$(function () {
    eventContentEllipsis();

    $('#KJETitle').before($('#calculatorTitle'));
    $('#calculatorTitle').removeClass('d-none');

    if (document.documentElement.clientWidth < 600) {
        $('.calculator-nav-item').each(function () {
            if ($(this).hasClass('active')) {
                $('.calculator-mobile-menu').css('display', 'block');
                $('.calculator-tabs').css('display', 'none');
            }
        });
    } else if (document.documentElement.clientWidth > 1023) {
        // focus on userid at load
        //$("#UserID", ".toolbar-login-cell").focus();
    }

    $(document).on('click', '#KJEViewReport', function () {
        if ($(this).val() === 'Hide Report') {
            $('#KJECalculatorScreenSize').removeClass('calculator-report-heading');
        } else {
            $('#KJECalculatorScreenSize').addClass('calculator-report-heading');
        }
    });

    $(document).on('click', function (event) {
        var $target = $(event.target);
        if($target.not('.KJEGuiDefnPopup').length && $target.not('.KJEDefinitionIcon').length){
            event.stopPropagation();
            var $popup = $('.KJEGuiDefnPopup[aria-hidden="false"]');
            var $parentInput = $popup.closest('.KJEInputContainer');
            var $definitionIcon = $parentInput.find('.KJEDefinitionIcon');
            $definitionIcon.trigger('click');
            $definitionIcon.attr('aria-expanded', 'false');
        }
    });

    $('.search-icon').on("click", function (e) {
        e.preventDefault();
        $loginSearchForm = $(e.target).closest('#login-search-form');
        $loginSearchForm.length && $loginSearchForm.trigger('submit');
    });

    $('.search-icon').on('keydown', function(e) {
        if(e.key == 'Enter' || e.key == ' ') {
          e.preventDefault();
          $(this).click();
        }
      })

    $('.nav-menu .nav-item a').on('click', function (e) {
        var target = $(e.target).attr('href');
        if (!target || target == '#') {
            e.preventDefault();
        }
    })
    //adding class to proxy voting form  page 
    if ($('.proxy-voting-form').length > 0) {
        $('.primary').addClass('primary-proxy');
        $('.page-content').addClass('primary-proxy');
    }

    // Search Functionality
    $(".btn-search").on("click", function (e) {
        e.preventDefault();
        $('.js-mobile-login').removeClass('mobile-login-open').attr('aria-expanded', 'false');

        $('#nav-icon3').removeClass('mobile-open open').attr('aria-selected', 'false');
        $('#mobile-menu').slideUp().attr('aria-hidden', 'true');

        $(".search-text").addClass("expanded");
        $(".toolbar").addClass("site-search-expanded");
        $(".close-btn").show();
        $('.search-icon').show();
        $('.search-icon').addClass('drag');
        $('.searchbox input[type=submit]').addClass('expand-search');
        $(this).css("visibility", "hidden");
    })

    $(document).on('click', '.close-btn', function (e) {
        e.preventDefault();
        $('.sticky-form').remove();
        $('body').removeClass('opacity noscroll');
        $('.sticky-form-mobile').hide();
        $('.sticky-form-mobile .search-icon').hide();
        $(".sticky-form-mobile .close-btn").hide();

    })
    $(document).on('click', '.sticky-form-mobile .close-btn', function (e) {
        e.preventDefault();
        $('body').addClass('opacity');
        $('.mobile-menu-list').show();
        $('.mobile-search').show();
        $('#mobile-menu').removeClass('menu-height');

    })

    $(".close-btn").on("click", function (e) {
        e.preventDefault();
        $(".search-text").removeClass("expanded").val("").removeAttr("style");
        $(".toolbar").removeClass("site-search-expanded");
        $(".close-btn").hide();
        $('.search-icon').hide();
        $('.search-icon').removeClass('drag');
        $(".btn-search").show().css("visibility", "visible");
        $('.sticky-search').show();
        $('body').removeClass('opacity noscroll');
        $('.searchbox input[type=submit]').removeClass('expand-search');

    })

    $('.close-btn').on("click", function (e) {
        e.preventDefault();
        $('.sticky-search').show();
        $('body').removeClass('opacity noscroll');
        $('.sticky-form').hide();
    })

    $(document).on('mouseenter', '.header-sticky ul.nav-menu .nav-item > a:not(.sticky-search)', function () {
        // Hide search
        $('.sticky-form').remove();
        // Hide login
        $('.js-mobile-login').removeClass('mobile-login-open').attr('aria-selected', 'false');
        // make body scrollable
        $('body').removeClass('noscroll');
    });

    //validation for OLB 

    $("form[name='signon-form']").validate({
        rules: {
            UserName: {
                required: true
            },
            Password: {
                required: true
            }
        },
        messages: {
            UserName: {
                required: "Please enter your User ID"
            },
            Password: {
                required: "Please enter your Password"
            },
        },
        submitHandler: function (form) {
            form.submit();
        }
    });

    $("form[name='signon-form-mobile']").validate({
        rules: {
            UserName: {
                required: true
            },
            Password: {
                required: true
            }
        },
        messages: {
            UserName: {
                required: "Please enter your User ID"
            },
            Password: {
                required: "Please enter your Password"
            },
        },
        submitHandler: function (form) {
            form.submit();
        }
    });

    $('.tab-mobile-menu .dropdown a').click(function (e) {
        $('.tab-mobile-menu .dropdown-item').removeClass('active show')
        $("#tabDropdownMenu").text($(this).text());
    })

    // auto jump selector for mobile
    $(".mobile-link-selector").on("change", function () {
        var url = $(":selected", $(this)).data("url");
        if (url) {
            window.location = url;
        }
        return false;
    });

      // js cutoff dates
      $(window).scroll(function () {
        if ($(window).width() >= 1024) {
            var scroll = $(window).scrollTop();
            if (scroll > 50) {
                $(".header-navigation").addClass("header-sticky");
                //$(".skip-links .hidden-above-lg:last-child").show();
                $('body').addClass('sticky');
                $('.alert-container').addClass('alert-container-sticky');
            } else {
                $(".header-navigation").removeClass("header-sticky");
                //$(".skip-links .hidden-above-lg:last-child").hide();
                $('body').removeClass('sticky');
                $('.alert-container').removeClass('alert-container-sticky');
                $('form.sticky-form ,form.sticky-form .close-btn, form.sticky-form .search-icon').hide();
            }
        }

        if ($(window).width() < 1024) {
            $('.alert-container').addClass('alert-container-sticky');
        }
    });



    var slideIndex = $('.calculator-tabs .calculator-nav-item').index($('.calculator-tabs .calculator-nav-item.active'));
    $('.tab-slider-nav').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        speed: 300,
        focusOnSelect: true,
        centerMode: true,
        centerPadding: 0,
        initialSlide: slideIndex != -1 ? slideIndex : 0
    });
    function unSlick() {
        $('.tab-slider-nav').slick('resize');
        var viewportWidth = jQuery(window).width();

        if (viewportWidth < 768) {
            $('.tab-slider-nav').slick('unslick');
        }
    }
    unSlick();
    jQuery(window).on('resize', function () {
        unSlick();
    });

    if ($('.image-link-blocks-slider').length) {
        $('.image-link-blocks-slider').slick({
            infinite: true,
            variableWidth: true,
            slidesToScroll: 1,
            speed: 600,
            focusOnSelect: true,
            initialSlide: 0,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        centerMode: true
                    }
                }
            ]
        });
    }

    $(document).ready(function () {
        $(".external-link-extended").on('click', function () {
            var externalLink = $(this).data("href");
            const event = new CustomEvent('speedbumpTriggered', { detail: { externalHref: externalLink }});
            document.dispatchEvent(event);
        });
        $("#find-medicare-check").change(function () {
            if (this.checked) {
                $("#find-medicare-button").removeClass("disabled");
            }
            else {
                $("#find-medicare-button").addClass("disabled");
            }
        });
        $("#find-medicare-zip").on("input", function () {
            if ($("#find-medicare-button")) {
                var original = $("#find-medicare-button").data("original");
                if (original && this.value) {
                    $("#find-medicare-button").data("href", original + this.value);
                }
            }
        });
        $("#covr-button").click(function () {
            var original = $(this).data("original");
            original = original.replace("{dob}", $("#covr-dob").val());
            original = original.replace("{gender}", document.querySelector('input[name="covr-gender"]:checked').value);
            original = original.replace("{tobacco}", document.querySelector('input[name="covr-tobacco"]:checked').value);
            original = original.replace("{height}", $("#covr-height").val());
            $(this).data("href", original);
        });
        $("#covr-check").change(function () {
            if (this.checked) {
                $("#covr-button").removeClass("disabled");
            }
            else {
                $("#covr-button").addClass("disabled");
            }
        });

        $("a[data-goal],button[data-goal]").on("click", function(){
            navigator.sendBeacon("/Events/TrackedLinkGoalHandler.ashx?gid=" + $(this).data("goal"));
        });

        $(document).on('click', '.btn-compare-card', function () {
            setTimeout(function () {
                $('#u2021-compareBtn.u2021-compare-cards-btn').click();
            }, 200);
        });
    });
});    

const formDropdownSelect = document.getElementById('combo1');
var savedIdx = null;

window.addEventListener("DOMContentLoaded", () => {
  initAllSelects();
  sitecoreValidationObserver();
});

function sitecoreValidationObserver() {
  const observer = new MutationObserver(() => {
    const summary = document.querySelector(".validation-summary-errors");
  
    if (summary) {
      initAllSelects();
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    attributeFilter: ["class"],
    subtree: true
  });
}

/*
*   This content is licensed according to the W3C Software License at
*   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
*/

// Save a list of named combobox actions, for future readability
const SelectActions = {
Close: 0,
CloseSelect: 1,
First: 2,
Last: 3,
Next: 4,
Open: 5,
PageDown: 6,
PageUp: 7,
Previous: 8,
Select: 9,
Type: 10,
};

/*
* Helper functions
*/

// map a key press to an action
function getActionFromKey(event, menuOpen) {
const { key, altKey, ctrlKey, metaKey } = event;
const openKeys = ['ArrowDown', 'ArrowUp', 'Enter', ' ']; // all keys that will do the default open action
// handle opening when closed
if (!menuOpen && openKeys.includes(key)) {
  return SelectActions.Open;
}

// home and end move the selected option when open or closed
if (key === 'Home') {
  return SelectActions.First;
}
if (key === 'End') {
  return SelectActions.Last;
}

// handle typing characters when open or closed
if (
  key === 'Backspace' ||
  key === 'Clear' ||
  (key.length === 1 && key !== ' ' && !altKey && !ctrlKey && !metaKey)
) {
  return SelectActions.Type;
}

// handle keys when open
if (menuOpen) {
  if (key === 'ArrowUp' && altKey) {
    return SelectActions.CloseSelect;
  } else if (key === 'ArrowDown' && !altKey) {
    return SelectActions.Next;
  } else if (key === 'ArrowUp') {
    return SelectActions.Previous;
  } else if (key === 'PageUp') {
    return SelectActions.PageUp;
  } else if (key === 'PageDown') {
    return SelectActions.PageDown;
  } else if (key === 'Escape') {
    return SelectActions.Close;
  } else if (key === 'Enter' || key === ' ') {
    return SelectActions.CloseSelect;
  }
}
}


// get an updated option index after performing an action
function getUpdatedIndex(currentIndex, maxIndex, action) {
const pageSize = 10; // used for pageup/pagedown

switch (action) {
  case SelectActions.First:
    return 0;
  case SelectActions.Last:
    return maxIndex;
  case SelectActions.Previous:
    return Math.max(0, currentIndex - 1);
  case SelectActions.Next:
    return Math.min(maxIndex, currentIndex + 1);
  case SelectActions.PageUp:
    return Math.max(0, currentIndex - pageSize);
  case SelectActions.PageDown:
    return Math.min(maxIndex, currentIndex + pageSize);
  default:
    return currentIndex;
}
}

// check if element is visible in browser view port
function isElementInView(element) {
var bounding = element.getBoundingClientRect();

return (
  bounding.top >= 0 &&
  bounding.left >= 0 &&
  bounding.bottom <=
    (window.innerHeight || document.documentElement.clientHeight) &&
  bounding.right <=
    (window.innerWidth || document.documentElement.clientWidth)
);
}

// check if an element is currently scrollable
function isScrollable(element) {
return element && element.clientHeight < element.scrollHeight;
}

// ensure a given child element is within the parent's visible scroll area
// if the child is not visible, scroll the parent
function maintainScrollVisibility(activeElement, scrollParent) {
const { offsetHeight, offsetTop } = activeElement;
const { offsetHeight: parentOffsetHeight, scrollTop } = scrollParent;

const isAbove = offsetTop < scrollTop;
const isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;

if (isAbove) {
  scrollParent.scrollTo(0, offsetTop);
} else if (isBelow) {
  scrollParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
}
}

/*
* Select Component
* Accepts a combobox element and an array of string options
*/
const Select = function (el, index ) {
  if (el.__selectInit) return;
  el.__selectInit = true;
// element refs
this.el = el;
this.labelEl = el.querySelector('.combo-label');
this.comboEl = el.querySelector('[role=combobox]');
this.listboxEl = el.querySelector('[role=listbox]');

// data
this.idBase = this.comboEl.id || 'combo';

// state
this.activeIndex = index === undefined ? -1 : index;
this.open = false;
this.searchString = '';
this.searchTimeout = null;

// init
if (el && this.comboEl && this.listboxEl) {
  this.init();
  if( savedIdx !== null) {
    this.onOptionChange( savedIdx );
    this.selectOption( savedIdx );
  }else if( this.activeIndex !== -1 && this.activeIndex !== undefined ) {
    this.onOptionChange( index );
    this.selectOption( index );}
  }
};

Select.prototype.init = function () {
const nodes = Array.from(this.listboxEl.children).filter( node => node && node.textContent && node.textContent.trim().length);
this.options = nodes.map( node => node.textContent.trim())

if( !this.options.length ) return;

this.listboxEl.innerHTML = '';

// add event listeners
this.labelEl.addEventListener('click', this.onLabelClick.bind(this));
this.comboEl.addEventListener('blur', this.onComboBlur.bind(this));
this.listboxEl.addEventListener('focusout', this.onComboBlur.bind(this));
this.comboEl.addEventListener("click", (e) => this.onComboClick(e), true);
this.comboEl.addEventListener('keydown', this.onComboKeyDown.bind(this));

// create options
this.options.map((option, index) => {
  const optionEl = this.createOption(option, index);
  this.listboxEl.appendChild(optionEl);
});
};

Select.prototype.createOption = function (optionText, index) {
  const optionEl = document.createElement('div');
  optionEl.setAttribute('role', 'option');
  optionEl.id = `${this.idBase}-${index}`;
  optionEl.className = 'combo-option';
  optionEl.setAttribute('aria-selected', 'false');
  optionEl.innerText = optionText;

  optionEl.addEventListener('click', (event) => {
    event.stopPropagation();
    this.onOptionClick(index);
  });
  optionEl.addEventListener('mousedown', this.onOptionMouseDown.bind(this));

  return optionEl;
};

Select.prototype.onLabelClick = function () {
this.comboEl.focus();
};

Select.prototype.onComboBlur = function (event) {
  // do nothing if relatedTarget is contained within listboxEl
  if (this.listboxEl.contains(event.relatedTarget)) {
    return;
  }

  if (this.open) {
    // close menu but do not auto select for user
    this.updateMenuState( false, false );
  }
};

Select.prototype.onComboClick = function (e) {
  if (e) { e.preventDefault(); e.stopPropagation(); }
  this.updateMenuState(!this.open, false);
};

Select.prototype.onComboKeyDown = function (event) {
const { key } = event;
const max = this.options.length - 1;

const action = getActionFromKey(event, this.open);

switch (action) {
  case SelectActions.Last:
  case SelectActions.First:
    this.updateMenuState(true);
  // intentional fallthrough
  case SelectActions.Next:
  case SelectActions.Previous:
  case SelectActions.PageUp:
  case SelectActions.PageDown:
    event.preventDefault();
    return this.onOptionChange(
      getUpdatedIndex(this.activeIndex, max, action)
    );
  case SelectActions.CloseSelect:
    event.preventDefault();
    this.selectOption(this.activeIndex);
  // intentional fallthrough
  case SelectActions.Close:
    event.preventDefault();
    return this.updateMenuState(false);
  case SelectActions.Type:
    return this.onComboType(key);
  case SelectActions.Open:
    event.preventDefault();
    return this.updateMenuState(true);
}
};

Select.prototype.onOptionChange = function (index) {
// update state
this.activeIndex = index;

// update aria-activedescendant
this.comboEl.setAttribute('aria-activedescendant', `${this.idBase}-${index}`);

// update active option styles
const options = this.el.querySelectorAll('[role=option]');
[...options].forEach((optionEl) => {
  optionEl?.classList?.remove('option-current');
});
options[index]?.classList?.add('option-current');

// ensure the new option is in view
if (isScrollable(this.listboxEl)) {
  maintainScrollVisibility(options[index], this.listboxEl);
}

// ensure the new option is visible on screen
if (!isElementInView(options[index])) {
  options[index].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}
};

Select.prototype.onOptionClick = function (index) {
this.onOptionChange(index);
this.selectOption(index);
this.updateMenuState(false);
};

Select.prototype.onOptionMouseDown = function () {
// Clicking an option will cause a blur event,
// but we don't want to perform the default keyboard blur action
this.ignoreBlur = true;
};

Select.prototype.selectOption = function (index) {
savedIdx = index;
// update state
this.selectedIndex = index;
this.activeIndex = index;

// update displayed value
const selected = this.options[index];
this.comboEl.innerHTML = selected;

if(selected) {
  var combo = document.querySelector('div.combo.js-select');
  combo.classList.remove('input-validation-error');
  var span = document.querySelector('span.field-validation-error.js-select-req-error');
  if(span) span.remove();
}


// submit the selected option
var hiddenId = this.el.getAttribute("data-hidden-input");
var hidden = hiddenId ? document.getElementById(hiddenId) : null;

if (hidden) {
  hidden.value = selected;

  if (window.jQuery) {
    window.jQuery(hidden).trigger("input").trigger("change");
  } else {
    hidden.dispatchEvent(new Event("input", { bubbles: true }));
    hidden.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
// update aria-selected
const options = this.el.querySelectorAll('[role=option]');
[...options].forEach((optionEl) => {
  optionEl.setAttribute('aria-selected', 'false');
});
options[index].setAttribute('aria-selected', 'true');
};

Select.prototype.updateMenuState = function (open, callFocus = true) {
this.open = open;

// update aria-expanded and styles
this.comboEl.setAttribute('aria-expanded', `${open}`);
open ? this.el.classList.add('open') : this.el.classList.remove('open');

// update activedescendant
const activeID = open ? `${this.idBase}-${this.activeIndex}` : '';
this.comboEl.setAttribute('aria-activedescendant', activeID);

if (activeID === '' && !isElementInView(this.comboEl)) {
  this.comboEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}

// move focus back to the combobox, if needed
callFocus && this.comboEl.focus();
};

document.querySelectorAll(".combo.js-select").forEach(combo => {
  const hiddenId = combo.getAttribute("data-hidden-input");
  const hidden = document.getElementById(hiddenId);
  const input = combo.querySelector(".combo-input");
  const options = combo.querySelectorAll(".combo-option");

  options.forEach(opt => {
    opt.addEventListener("click", () => {
      const value = opt.getAttribute("data-value");
      const text = opt.textContent.trim();

      // Update visible UI
      input.textContent = text;

      // Update Sitecore-bound value
      if (hidden) {
        hidden.value = value;
        hidden.dispatchEvent(new Event("change", { bubbles: true }));
      }

      // ARIA state
      options.forEach(o => o.setAttribute("aria-selected", "false"));
      opt.setAttribute("aria-selected", "true");
    });
  });
});

// const comboInputText = document.querySelector('.combo-input').innerHTML;
comboInput = document.querySelector('.combo-input');

  function initAllSelects(root = document) {
    root.querySelectorAll(".js-select").forEach((el) => new Select(el));
  }

  function validateComboOnSubmit(formEl) {
    var $form = $(formEl);

    const isReq = $form.find(".js-combo-hidden[data-val='true'][data-val-required]").length
    if( !isReq ) return true;
    
    var v = $form.data("validator");

    // If validator exists, make sure hidden proxy isn't ignored
    if (v && v.settings) {
      v.settings.ignore = ":hidden:not(.js-combo-hidden)";
      return $form.valid(); // blocks if required hidden is empty
    }

    // Fallback: if validator isn't attached, at least block if our proxy is empty AND required
    // (prevents the "submits anyway" case)
    var $proxy = $form.find(".js-combo-hidden[data-val='true'][data-val-required]");
    if ($proxy.length) {
      var emptyRequired = $proxy.toArray().some(function (el) {
        return !$(el).val();
      });

      if (emptyRequired) {
        return false;
      }
    }

    return true;
  }

  document.addEventListener('submit', (e) => {
    var formEl = e.target.closest('form.sitecore-form');
    if (!formEl || formEl.tagName !== "FORM") return;
  
    if (!validateComboOnSubmit(formEl)) {
      e.preventDefault();

      var comboHidden = formEl.querySelector('input.js-combo-hidden');
      
      if(comboHidden && comboHidden.value === ''){
        var reqMessage = document.querySelector('span.js-select-req-error');
        if( reqMessage ) return;
        var combo = document.querySelector('div.combo.js-select');
        var message = comboHidden.getAttribute('data-val-required');
        combo.classList.add('input-validation-error');
        var name = comboHidden.getAttribute('name');
        if (!name) return;
        var span = document.createElement('span');
        span.className = 'field-validation-error js-select-req-error';
        span.innerHTML = message;
        combo.insertAdjacentElement('afterend', span);
      }
    } 
  }, true);

 // resets original form fields when user navigates back to form after being redirected.
  window.addEventListener("pageshow", () => {
    const nav = performance.getEntriesByType("navigation")[0];
    if (nav && nav.type === "back_forward") {
      const formEl = document.querySelector("form.sitecore-form");
      formEl.reset();
    }
  });